// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .sizing-group-list {
  overflow-x: auto;
}
.presize-root .sizing-group-list .sizing-group:not(:last-child) {
  padding-bottom: 44px;
  border-bottom: 1px solid #efefef;
}
.presize-root .cg-confirm .ant-btn-primary {
  border-color: #be3013;
  color: #be3013;
  text-shadow: none;
  background-color: white;
}
/*# sourceMappingURL=SizingGroupList.css.map */`, "",{"version":3,"sources":["webpack://./SizingGroupList.less","webpack://./src/pages/SizingGroupList/SizingGroupList.less"],"names":[],"mappings":"AAAA;EAEE,gBAAA;ACAF;ADFA;EAKI,oBAAA;EACA,gCAAA;ACAJ;ADNA;EAYI,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;ACHJ;AACA,8CAA8C","sourcesContent":[".presize-root { \n .sizing-group-list {\n  overflow-x: auto;\n\n  .sizing-group:not(:last-child) {\n    padding-bottom: 44px;\n    border-bottom: 1px solid #efefef;\n  }\n}\n\n.cg-confirm {\n  .ant-btn-primary {\n    border-color: #be3013;\n    color: #be3013;\n    text-shadow: none;\n    background-color: white;\n  }\n}\n \n}",".presize-root .sizing-group-list {\n  overflow-x: auto;\n}\n.presize-root .sizing-group-list .sizing-group:not(:last-child) {\n  padding-bottom: 44px;\n  border-bottom: 1px solid #efefef;\n}\n.presize-root .cg-confirm .ant-btn-primary {\n  border-color: #be3013;\n  color: #be3013;\n  text-shadow: none;\n  background-color: white;\n}\n/*# sourceMappingURL=SizingGroupList.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
